import { render, staticRenderFns } from "./baserFooter.vue?vue&type=template&id=dcb3682c&scoped=true"
import script from "./baserFooter.vue?vue&type=script&lang=js"
export * from "./baserFooter.vue?vue&type=script&lang=js"
import style0 from "./baserFooter.vue?vue&type=style&index=0&id=dcb3682c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb3682c",
  null
  
)

export default component.exports